<template>
  <div class="page flex-col">
    <!-- 顶部由全局 SiteHeader 渲染，这里仅保留页面主体 -->
    <div class="group_2 flex-col">
      <!-- 将标题与面包屑移动到最上方 -->
      <!-- 已移除顶部蓝色标题块：text-wrapper_2 -->
      <!-- 已删除：标题与当前位置面包屑 -->
      <!-- 其后再展示左侧菜单与正文内容 -->
      <div class="image-text_1 flex-row justify-between">
        <LanhuSideMenu :contentType="contentType" @switch="switchContent" />
        <LanhuDetailContent :content="currentContent" :pdfUrl="currentPdfUrl" />
      </div>
    </div>
    <!-- 底部深色模块移除，统一由全局 SiteFooter 控制背景与内容 -->
  </div>
</template>
<script>
import LanhuSideMenu from '../../components/LanhuSideMenu.vue'
import LanhuDetailContent from '../../components/LanhuDetailContent.vue'
export default {
  components: { LanhuSideMenu, LanhuDetailContent },
  data() {
    return {
      contentTitle: '成果内容',
      contentType: '课程资源',
      currentContent: '',
      currentPdfUrl: ''
    };
  },
  methods: {
    buildValueHtml(type) {
      const paragraphs = {
        '德技双馨': [
          '<strong>人才培养质量全面提升，实现德技并修高质量发展</strong>',
          '成果实施以来，人才培养质量显著提升。近三届毕业生最终就业率均稳定在98%以上（2023年达99.14%），专业对口率提升至40%以上，显著高于全国高职平均水平；跨境电商数智化岗位（如智能运营、数据诊断）占比达 65% ，新质技能适配度显著高于行业平均水平。麦可思数据显示，毕业生对教学的满意度、就业满意度、对母校的满意度等核心指标连续多年位列全校前三。',
          '学生职业技能与创新精神显著增强，在全国职业院校技能大赛中获一等奖2项、二等奖1项，在世界职业院校技能大赛中获得银奖1项、铜奖2项，在“互联网+”大学生创新创业大赛中获国家级铜奖1项、省级金奖1项。毕业生可持续发展能力强，专升本录取比率高达87%，稳居全校第一，并涌现出以义乌五金协会协会副会长李荣军（安徽省“创业之星”）为代表的一批创业典型，形成“就业有竞争力、升学有基础、创业有能力”的良性发展格局。'
        ],
        '教学示范': [
          '<strong>教学资源与模式广泛辐射，形成专业建设示范标杆</strong>',
          '成果所凝练的育人模式已成为可复制、可推广的改革范式，在校内外产生广泛影响。建成国家级精品在线课程2门、国家级教学资源库课程3门，主编“十四五”国家规划教材2本、省级规划教材7本，数字化资源惠及学生超2万人次。师资团队拥有省级教学名师2人、省级教学团队2个，获国家级教学能力大赛奖项4项。实训基地建设成果成为学校样板，接待逾10所省内外兄弟院校观摩学习。成果的先进理念与实操路径得到高度认可，牵头安徽省“1+X”跨境电商B2B证书试点，成功承办“全国跨境电商B2B数据运营‘1+X’师资培训”（合肥站）及国培项目等，累计为全国9个省份、全省20余所高职院校的百余名教师提供了培训与交流平台，获省级优秀案例一等奖。成果核心内容亦被全国报关行指委年会等高水平会议采纳交流，人才培养新模式在省内乃至全国范围内起到重要示范作用，产教融合案例两次获安徽省校企合作典型案例一等奖。'
        ],
        '服务社会': [
          '<strong>社会服务能力持续增强，有效赋能行业与区域发展</strong>',
          '成果有效赋能区域经济发展与行业升级，社会服务能力显著增强。专业教师团队深度参与行业服务，5名教师受聘为安徽省进出口商会业务与政策指导专家，面向地方政府与企业开展“RCEP 规则与跨境电商数智运营”等培训，覆盖全省 8 地市 120 家企业，累计培训人员近万人次。依托校政行企共建的产业学院与研究平台，培育新质技能人才，助力安徽“徽动全球”出海行动——为合肥荣事达小家电、芜湖三只松鼠等企业提供“智能选品 + 海外本土化运营”技术支持，助力企业提升数字化运营能力，推动安徽特色产品通过跨境电商出口额年均增长 18%，凸显 “安徽工商方案” 的区域价值。连续三年承办省级关务技能大赛，主办全国性行业会议，成为区域跨境电商教育与交流的核心平台。'
        ],
        '引领示范': [
          '<strong>示范引领效应不断凸显，成果获社会各界广泛认可</strong>',
          '成果的扎实成效与创新价值获得了教育主管部门、行业组织及社会媒体的高度评价。学校担任全国跨境电商产教联盟副理事长单位等7个行业组织职务，参与国家教学标准研制。实训基地建设成果得到安徽省教育厅等领导现场视察时的充分肯定。相关改革实践被主流媒体关注报道，专业的建设成效与人才培养案例形成了良好的社会声誉。在多项权威评价中，学校的相关专业竞争力位居全国前列，成果为高职院校跨境电商领域深化产教融合、提升人才培养质量提供了成功的“安徽工商”方案，示范引领作用日益彰显。'
        ]
      };
      const ps = paragraphs[type] || [];
      return ps.map(p => `<p>${p}</p>`).join('');
    },
    mapFilename(type) {
      const map = {
        '课程资源': '1.课程资源',
        '竞赛引领': '2.竞赛引领',
        '数智融合': '3.数智融合',
        '文化浸润': '4.文化浸润',
        '证书赋能': '5.证书赋能',
        '实训基地': '6.实训基地',
        '双师团队': '7.双师团队',
        '资源辐射': '8.资源辐射'
      };
      return map[type] || '1.课程资源';
    },
    getPdfUrl(type) {
      const pdfMap = {
        '课程资源': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/1.%E8%AF%BE%E7%A8%8B%E8%B5%84%E6%BA%90.pdf',
        '竞赛引领': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/2.%E7%AB%9E%E8%B5%9B%E5%BC%95%E9%A2%86.pdf',
        '数智融合': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/3.%E6%95%B0%E6%99%BA%E8%9E%8D%E5%90%88.pdf',
        '文化浸润': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/4.%E6%96%87%E5%8C%96%E6%B5%B8%E6%B6%A6.pdf',
        '证书赋能': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/5.%E8%AF%81%E4%B9%A6%E8%B5%8B%E8%83%BD.pdf',
        '实训基地': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/6.%E5%AE%9E%E8%AE%AD%E5%9F%BA%E5%9C%B0.pdf',
        '双师团队': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/7.%E5%8F%8C%E5%B8%88%E5%9B%A2%E9%98%9F.pdf',
        '资源辐射': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/pdf/8.%E8%B5%84%E6%BA%90%E8%BE%90%E5%B0%84.pdf'
      };
      return pdfMap[type] || pdfMap['课程资源'];
    },
    async loadContent(type) {
      // 成果价值四个二级菜单：直接显示文本且不提供 PDF 预览
      if (['德技双馨','教学示范','服务社会','引领示范'].includes(type)) {
        this.currentPdfUrl = '';
        this.currentContent = this.buildValueHtml(type);
        this.contentTitle = type;
        this.contentType = type;
        return;
      }
      const base = this.mapFilename(type);
      // 设置 PDF 预览地址（使用云存储地址）
      this.currentPdfUrl = this.getPdfUrl(type);
      // 加载文本内容（如存在 .txt，则展示在页面上）
      try {
        const resp = await fetch(`/neirong/${base}.txt`);
        if (resp.ok) {
          const text = await resp.text();
          // 将换行转换为 <br/>，并简单转义
          const html = text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\n/g, '<br/>');
          this.currentContent = html;
        } else {
          this.currentContent = '';
        }
      } catch (e) {
        this.currentContent = '';
      }
    },
    switchContent(type) {
      this.contentType = type;
      this.contentTitle = type;
      this.loadContent(type);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 根据路由参数初始化内容类型
      const initType = (this.$route && this.$route.query && this.$route.query.type) ? this.$route.query.type : this.contentType;
      this.switchContent(initType);
    });
  },
  watch: {
    // 监听头部下拉切换后的路由变化，更新当前展示内容
    $route(to) {
      const type = (to && to.query && to.query.type) ? to.query.type : '';
      if (type) {
        this.switchContent(type);
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<!-- 移除本页局部导航的下拉样式与下划线样式，统一由 SiteHeader 控制 -->
